import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import MainFeature1 from "components/features/TwoColWithButton.js";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature3 from "components/features/TwoColSingleFeatureWithStats2.js";
import Features from "components/features/ThreeColSimple.js";
// import Features from "components/features/ThreeColWithSideImage.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid";

import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomerLoveIconImage from "images/simple-icon.svg";

// To use NavBar
import HeaderBase, {
  LogoLink as LogoLinkBase,
  NavLinks,
  NavLink as NavLinkBase,
  PrimaryLink as PrimaryLinkBase,
} from "components/headers/light.js";
import logo from "images/logo.png";
import logoImageSrc from "images/logo.png";
import TwoColWithTwoFeaturesAndButtons from "components/features/TwoColWithTwoFeaturesAndButtons";
import TwoColWithSteps from "components/features/TwoColWithSteps";
import TwoColWithButton from "components/features/TwoColWithButton.js";
import TwoColumnWithImageAndRating from "components/testimonials/TwoColumnWithImageAndRating";

const NavLink = tw.a`mt-4 lg:mt-0 transition duration-300 font-medium pb-1 border-b-2 mr-12 text-gray-700 border-gray-400 hocus:border-gray-700`;
const PrimaryNavLink = tw(
  NavLink
)`text-gray-100 bg-blue-500 px-6 py-3 border-none rounded hocus:bg-blue-900 focus:shadow-outline mt-6 md:mt-4 lg:mt-0`;
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Row = tw.div`flex`;

const NavRow = tw(Row)`flex flex-col lg:flex-row items-center justify-between`;

export default () => {
  const Header = tw(HeaderBase)`max-w-none -mt-8 py-8 -mx-8 px-8 bg-blue-900`;
  const NavLink = tw(
    NavLinkBase
  )`lg:text-gray-100 lg:hocus:text-gray-300 lg:hocus:border-gray-100`;
  const LogoLink = tw(LogoLinkBase)`text-gray-100 hocus:text-gray-300`;
  const PrimaryLink = tw(
    PrimaryLinkBase
  )`shadow-raised lg:bg-blue-400 lg:hocus:bg-blue-500`;

  const navLinks = [
    <NavLinks key={1}>
      <NavLink href="/components/innerPages/AboutUsPage">About Us</NavLink>
      <NavLink href="/components/innerPages/ProjectsPage">Projects</NavLink>
      <NavLink href="/components/innerPages/BlogIndexPage">Services</NavLink>
      <PrimaryLink href="/components/innerPages/ContactUsPage">
        Get A Quote
      </PrimaryLink>
    </NavLinks>,
  ];

  const logoLink = (
    <LogoLink href="/">
      <img src={logoImageSrc} alt="Logo" />
      Great Wave Digital
    </LogoLink>
  );
  return (
    <AnimationRevealPage>
      {/* <Header logoLink={logoLink} links={navLinks} /> */}
      <TwoColumnWithImageAndRating />
      <Features
        subheading={<Subheading>Our Values</Subheading>}
        heading="We follow these."
        description="Design Quote"
        cards={[
          {
            imageSrc: SupportIconImage,
            title: "Communication",
            description:
              "We believe the key to delivering an excellent project is great communication.",
          },
          {
            imageSrc: ShieldIconImage,
            title: "Security",
            description:
              "Our sites are secure and with our maintenance plan we will protect your site and backup your data regularly.",
          },
          {
            imageSrc: CustomerLoveIconImage,
            title: "Customer Satisfaction",
            description:
              "During the design process, our team will ask engaging questions to see what theme and design works best for your business.",
          },
        ]}
        linkText=""
      />
      <TeamCardGrid subheading={<Subheading>Our Team</Subheading>} />
    </AnimationRevealPage>
  );
};
